



















import { Content, Row } from '@neurotrack/web-shared-components'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'LearnContent',
  components: { Row, Content },
  props: {
    category: String
  },
  data() {
    return {
      items: [],
      sectionHeader: ''
    }
  },
  mounted() {
    this.items = this.getCategoryItems(this.category?.toUpperCase())
  },
  computed: {
    ...mapGetters('content/learn', ['getCategoryItems', 'getCategoryText'])
  },
  methods: {
    goToPath(category: string, id: string): void {
      this.$router.push({
        name: 'categorySlug',
        params: {
          category,
          slug: this.parseId(id)
        }
      })
    },
    parseId(slug: string): string {
      const parts: string[] = slug.split('/')
      return parts[parts.length - 1]
    }
  }
})
